import { render, staticRenderFns } from "./NotebookMap.vue?vue&type=template&id=c989a022&scoped=true&"
import script from "./NotebookMap.vue?vue&type=script&lang=js&"
export * from "./NotebookMap.vue?vue&type=script&lang=js&"
import style0 from "./NotebookMap.vue?vue&type=style&index=0&id=c989a022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c989a022",
  null
  
)

component.options.__file = "NotebookMap.vue"
export default component.exports